import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import {date, gameImage, getLinkPath, time} from 'app/utils';
import heroTablet from 'images/matches/man-tablet.png';
import heroMobile from 'images/matches/man-mobile.png';
import GamerPhoto from 'app/components/bet_form/GamerPhoto';
import {fixed3} from 'app/utils/fixed';
import {linkAndroid, linkIOSDownload, linkLine} from 'app/utils/app_links';
import logEvent from 'app/amplitude/log_event';
import SvgLogoEgb from 'images/logos/egb-logo.svg';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import Get from 'app/utils/Get';

const Bonus = () => <div className="advertising__left">
    <div className="get_bonus-wrap">
        <div className="get_bonus">
            <h1 className="get_bonus__title">
                <span className="get_bonus__title_1">
                    {I18n.t('advertising.title1')}
                </span>
                <span className="get_bonus__title_2">
                    {I18n.t('advertising.title2')}
                </span>
                <span className="get_bonus__title_3">
                    {I18n.t('advertising.title3')}
                </span>
            </h1>
        </div>
    </div>
    <div className="advertising__hero-wrap">
        <div className="advertising__hero">
            <picture>
                <source srcSet={heroTablet} media="(min-width: 768px)"/>
                <img
                    src={heroMobile}
                    alt={`${I18n.t('advertising.title1')} ${I18n.t('advertising.title2')} ` +
                            `${I18n.t('advertising.title3')} ${I18n.t('advertising.up_to')} $600!`}
                />
            </picture>
        </div>
        <div className="up_to">
            {I18n.t('advertising.up_to')} $600!
        </div>
    </div>
</div>;

const TeamName = ({coef, gamer}) => <div className="team-name-rate">
    <div className="team-name">{gamer.nick}</div>
    <div className="team-rate">{fixed3(coef)}</div>
</div>;

const TeamLogo = ({gamer}) => <div className="team-logo"><GamerPhoto line_gamer={gamer}/></div>;

const TeamLeft = ({coef, gamer}) => <div className="team">
    <TeamName coef={coef} gamer={gamer}/>
    <TeamLogo gamer={gamer}/>
</div>;

const TeamRight = ({coef, gamer}) => <div className="team">
    <TeamLogo gamer={gamer}/>
    <TeamName coef={coef} gamer={gamer}/>
</div>;

export default class AdvertisingLanding extends PureComponent {
    state = {
        matches: []
    };

    componentDidMount() {
        new Get({url: getLinkPath('/matches')})
            .execute()
            .then(response => response.json())
            .then(data => {
                this.setState({matches: data.matches || []});
            });
    }

    placeBetClick = () => {
        logEvent('PROMO_LANDING_INTERACTION', {SOURCE: 'PLACE_A_BET_TAPPED'});
    };

    handleAmplitudeEventIosTap = () => {
        logEvent('PROMO_LANDING_INTERACTION', {SOURCE: 'IOS_APP_TAPPED'});
    };

    handleAmplitudeEventAndroidTap = () => {
        logEvent('PROMO_LANDING_INTERACTION', {SOURCE: 'ANDROID_APP_TAPPED'});
    };

    render = () => <div className="advertising">
        <div className="advertising__inner">
            <div className="header">
                <div className="wrap wrap-wide wrap-wide--header">
                    <a href={getLinkPath('/')} className="logo-landing-promo ladder-game">
                        <img src={SvgLogoEgb} alt="EGB.com" title="EGB.COM"/>
                    </a>
                    <div className="header__content">
                        <div className="header__controls">
                            <div className="header__control reg-button">
                                <a
                                    className="btn undefined"
                                    href="/play/bets?sign_up=true">
                                    {I18n.t('user.registration')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-block tap_bar-hide">
                <div className="wrap wrap-wide wrap-wide--content">
                    <div id="react-content" className="content">
                        <div className="advertising__content">
                            <div className="advertising__content__inner">
                                <Bonus/>
                                <div className="advertising__right">
                                    <div className="terms_conditions desktop--hidden">
                                        <a href={getLinkPath('/terms_and_conditions')}>
                                            {I18n.t('terms_and_conditions')}
                                        </a>
                                    </div>
                                    <div className="match__list">
                                        {this.state.matches.map(
                                            line => <div className="match" key={line.hash_id}>
                                                <div className="match-row">
                                                    <TeamLeft coef={line.coef_1} gamer={line.gamer1}/>
                                                    <div className="match-info">
                                                        <div className="match-game">
                                                            <div className="match-game-logo">
                                                                {gameImage(line.filter)}
                                                            </div>
                                                            <div className="match-game-date">
                                                                <span className="match-game-date-day">
                                                                    {date(line.date)}
                                                                </span>
                                                                <span className="match-game-date-time">
                                                                    {time(line.date)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="match-actions mobile--hidden">
                                                            <a
                                                                onClick={this.placeBetClick}
                                                                href={linkLine(line.hash_id)}
                                                                className="btn btn--invert"
                                                            >
                                                                {I18n.t('place_a_bet_full')}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <TeamRight coef={line.coef_2} gamer={line.gamer2}/>
                                                </div>
                                                <div className="match-actions mobile--show">
                                                    <a
                                                        onClick={this.placeBetClick}
                                                        href={linkLine(line.hash_id)}
                                                        className="btn btn--invert"
                                                    >
                                                        {I18n.t('place_a_bet_full')}
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <div className="advertising__footer">
                                <div className="advertising__footer__inner">
                                    <div className="advertising__footer--column desktop--show">
                                        <a href={getLinkPath('/terms_and_conditions')}>
                                            {I18n.t('advertising.terms_conditions')}
                                        </a>
                                    </div>
                                    <div className="advertising__footer--column advertising__footer--column--app">
                                        <a
                                            id="ios_app_download"
                                            onClick={this.handleAmplitudeEventIosTap}
                                            className="advertising__app-link"
                                            href={linkIOSDownload()}
                                        >
                                            <SpriteIcon name="#svg-app_store" className="svg-default" size={{height: 50, width: 149}}/>
                                        </a>
                                        <a
                                            id="android_app_download"
                                            onClick={this.handleAmplitudeEventAndroidTap}
                                            className="advertising__app-link"
                                            href={linkAndroid()}
                                        >
                                            <SpriteIcon name="#svg-google_play" className="svg-default" size={{height: 50, width: 150}}/>
                                        </a>
                                    </div>
                                    <div className="advertising__footer--column">
                                        <div className="payment-system__list">
                                            <span className="payment-system">
                                                <SpriteIcon name="#svg-master_card" size={{height: 20, width: 55}}/>
                                            </span>
                                            <span className="payment-system">
                                                <SpriteIcon name="#svg-visa" size={{height: 36, width: 53}}/>
                                            </span>
                                        </div>
                                        <div className="license-list">
                                            <div id="license">
                                                <div
                                                    id="apg-seal-container"
                                                    data-apg-seal-id="e91736fd-7812-4361-9ecb-526f856f4d68"
                                                    data-apg-image-size="128"
                                                    data-apg-image-type="basic-small"
                                                />
                                            </div>

                                            <SpriteIcon name="#svg-eighteenplus-adv" size={{height: 44, width: 45}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
